import React from "react";
import { View, type StyleProp, type ViewStyle } from "react-native";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";

interface BottomFadeProps {
  /** Colour the fade ends in (the surface behind the scrolling content). */
  color: string;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

/**
 * Vertical fade from transparent to `color`, drawn with react-native-svg so it
 * needs no extra dependency and works on web and native alike.
 */
const BottomFade: React.FC<BottomFadeProps> = ({ color, style, testID }) => (
  <View pointerEvents="none" style={style} testID={testID}>
    <Svg width="100%" height="100%" preserveAspectRatio="none">
      <Defs>
        <LinearGradient id="bottomFade" x1="0" y1="0" x2="0" y2="1">
          <Stop offset="0" stopColor={color} stopOpacity={0} />
          <Stop offset="1" stopColor={color} stopOpacity={1} />
        </LinearGradient>
      </Defs>
      <Rect x="0" y="0" width="100%" height="100%" fill="url(#bottomFade)" />
    </Svg>
  </View>
);

export default BottomFade;
